import '../helpers/closestPolyfill';

export function initializeLightbox(): void {

    const lightboxElements: any = ([]).slice.call(
        document.querySelectorAll(lightboxDataAttr)
    );

    if (!lightboxElements) {
        return;
    }
    document.addEventListener("click", (e) => OverlayClick(e.target as HTMLElement));

    const lightboxOpenTrigger = '[data-trigger="lightbox-open"]';
    const openTriggerElements: HTMLElement[] = ([]).slice.call(
        document.querySelectorAll(lightboxOpenTrigger)
    );

    const slideIndexAttr = '[data-slide-index]';

    openTriggerElements
        .forEach(function (el: HTMLElement, i) {
            let slideElement = el.closest(slideIndexAttr) as HTMLElement;
            let triggerIndex = slideElement.dataset.slideIndex;
            el.addEventListener('click', function () {
                toggleBodyClass();

                let lightboxElement = lightboxElements[triggerIndex] as HTMLElement;
                // show corresponding lightbox
                lightboxElement.style.display = 'block';

                let galleryItem = el.closest('.adage-gallery-item');

                let galleryVideo = galleryItem.querySelector('[data-gallery-video]') as HTMLElement;
                if (!galleryVideo) return;

                // pause video in gallery when opening lightbox
                if (galleryVideo.tagName === 'VIDEO') {
                    (galleryVideo as HTMLVideoElement).pause();
                } else if (galleryVideo.tagName === 'IFRAME') {
                    tryPauseYoutubeIframe(galleryVideo as HTMLIFrameElement);
                }
            });
        });

    const lightboxCloseTrigger = '[data-trigger="lightbox-close"]';
    const closeTriggerElements: HTMLElement[] = ([]).slice.call(
        document.querySelectorAll(lightboxCloseTrigger)
    );

    closeTriggerElements.forEach(function (el: HTMLElement) {
        el.addEventListener('click', function () {
            toggleBodyClass();

            let lightboxWrapper = this.closest(lightboxDataAttr) as HTMLElement;

            tryPauseYoutubeIframe(lightboxWrapper.querySelector("iframe"));
            // hide lightbox again;
            lightboxWrapper.style.display = 'none';
        });
    });

}
const lightboxDataAttr = '[data-lightbox]';
const lightboxOverlay = '[data-overlay]';
const BodyModalOpenClass = "modal-open";

function toggleBodyClass() {
    let body = document.querySelector('body');

    if (body.classList.contains(BodyModalOpenClass)) {
        body.classList.remove(BodyModalOpenClass);
    }
    else {
        body.classList.add(BodyModalOpenClass);
    }
}

function OverlayClick(target: HTMLElement) {
    let lightboxWrapper = target.closest(lightboxDataAttr) as HTMLElement;
    if (!lightboxWrapper) return;

    let overlay = lightboxWrapper.querySelector(lightboxOverlay);
    if (target === overlay) {
        let galleryVideo = lightboxWrapper.querySelector('[data-lightbox-video]') as HTMLElement;
        if (galleryVideo) {
            // pause video in gallery when opening lightbox
            if (galleryVideo.tagName === 'VIDEO') {
                (galleryVideo as HTMLVideoElement).pause();
            } else if (galleryVideo.tagName === 'IFRAME') {
                tryPauseYoutubeIframe(galleryVideo as HTMLIFrameElement);
            }
        }
        lightboxWrapper.style.display = 'none';
        toggleBodyClass();
    }
}

function tryPauseYoutubeIframe(iframe: HTMLIFrameElement) {
    if (iframe) {
        try {
            iframe.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        }
        catch (ex) { }
    }
}